export default __webpack_public_path__ + "static/media/brakekit-small-red.2a530aca.webp";